import { apiConfig } from "@/helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const therapistsService = {
    
    getAll,
    getDetails,
    save,
    addTherapistBreaks,
    UpdateTherapistBreak,
    DeleteTherapistBreak,
    getAllHolidays,
    AddTherapistHoliday,
    UpdateTherapistHoliday,
    DeleteTherapistHoliday,
    GetShortBreaks,
    AddShortBreak,
    DeleteTherapistShortBreak,
    AddIcd9Category,
    DeleteIcd9Category,
    GetMedicalProfessions,
    GetTypyWizyt,
    InsertTypWizyty,
    UpdateTypWizyty,
    GetTypWizyty,
    GetWszystkieTypyWizyt,
    GetAdditionalOpenDays,
    AddAdditionalOpenDay,
    UpdateAdditionalOpenDay,
    DeleteAdditionalOpenDay,
    GetCalendarAdditionalOpenDays,
    GetTherapistFreeShedules,
    UploadTherapistCertificate,
    SaveCertPassword,
    getTherapistGroups,
    addTherapistGroup,
    deleteTherapistGroup,
    updateTherapistGroup
};

function getAll(data)
{
    return axios.get('/api/services/app/Therapists/GetAll', {
        params: {  
            SearchText: data.query,          
            SkipCount: (data.page-1) * data.limit,
            MaxResultCount: data.limit,
            IsActive: data.IsActive,
            GetSchedules: data.GetSchedules
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })
}
function getDetails(userId)
{
    return axios.get('/api/services/app/Therapists/GetTherapistDetails', {
        params: {            
          userId: userId
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })
}
function save(data)
{
    return axios.post('/api/services/app/Therapists/SaveOrUpdate',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })
}
function addTherapistBreaks(data)
{
    return axios.post('/api/services/app/Therapists/AddTherapistBreaks',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })
}
function UpdateTherapistBreak(data)
{
    return axios.put('/api/services/app/Therapists/UpdateTherapistBreak',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })
}
function DeleteTherapistBreak(id)
{
    return axios.delete('/api/services/app/Therapists/DeleteTherapistBreak', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }           
    })        
}
function getAllHolidays(data)
{
    return axios.get('/api/services/app/Therapists/GetHolidays', {
        params: {            
            SkipCount: (data.page-1) * data.limit,
            MaxResultCount: data.limit,      
            TherapistID: data.therapistid             
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })    
}
function AddTherapistHoliday(data)
{
    return axios.post('/api/services/app/Therapists/AddTherapistHoliday',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })
}
function UpdateTherapistHoliday(data)
{
    return axios.put('/api/services/app/Therapists/UpdateTherapistHoliday',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })
}
function DeleteTherapistHoliday(id)
{
    return axios.delete('/api/services/app/Therapists/DeleteTherapistHoliday', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }           
    })        
}
function GetShortBreaks(data)
{
    return axios.get('/api/services/app/Therapists/GetShortBreaks', {
        params: {
            SkipCount: (data.page-1) * data.limit,
            MaxResultCount: data.limit,
            TherapistID: data.therapistid
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function AddShortBreak(data)
{
    return axios.post('/api/services/app/Therapists/AddTherapistShortBreak',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function DeleteTherapistShortBreak(id)
{
    return axios.delete('/api/services/app/Therapists/DeleteTherepistShortBreak', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function AddIcd9Category(category,therapistId)
{
    return axios.post('api/services/app/Therapists/AddTherapistICD9Category', {category: category, therapistId: therapistId}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function DeleteIcd9Category(id)
{
    return axios.delete('/api/services/app/Therapists/DeleteTherapistICD9Category', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function GetMedicalProfessions()
{
    return axios.get('/api/services/app/Therapists/GetMedicalProfessions', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function GetTypyWizyt(userid)
{
    return axios.get('/api/services/app/Therapists/GetTypyWizytTerapeuty', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            userid: userid
        }
    })
}
function InsertTypWizyty(data)
{
    return axios.post('api/services/app/Therapists/InsertTypWizytyTerapeuty', data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function UpdateTypWizyty(data)
{
    return axios.put('api/services/app/Therapists/UpdateTypWizytyTerapeuty', data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function GetTypWizyty(id)
{
    return axios.get('/api/services/app/Therapists/GetTypWizyty', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function GetWszystkieTypyWizyt()
{
    return axios.get('/api/services/app/Therapists/GetWszystkieTypyWizyt', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function GetAdditionalOpenDays(data)
{
    return axios.get('/api/services/app/Therapists/GetAdditionalOpenDays', {
        params: {
            SkipCount: (data.page-1) * data.limit,
            MaxResultCount: data.limit,
            TherapistID: data.therapistid,
            Sorting: data.sorting
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}

function AddAdditionalOpenDay(data)
{
    return axios.post('api/services/app/Therapists/AddTherapistAdditionalOpenDay', data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function UpdateAdditionalOpenDay(data)
{
    return axios.put('api/services/app/Therapists/UpdateTherapistAdditionalOpenDay', data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function DeleteAdditionalOpenDay(id)
{
    return axios.delete('/api/services/app/Therapists/DeleteTherapistAdditionalOpenDay', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function GetCalendarAdditionalOpenDays(data)
{
    return axios.get('/api/services/app/Therapists/GetCalendarAdditionalOpenDays', {
        params: {
            start: data.start,
            end: data.end,
            placowkaId: data.placowkaId
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function GetTherapistFreeShedules(data)
{
    return axios.get('/api/services/app/Therapists/GetTherapistFreeShedules', {
        params: {
            startDate: data.startDate,
            typWizyty: data.typWizyty,
            therapistId: data.therapistId,
            ileDat: data.ileDat
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function UploadTherapistCertificate(data)
{
    let headers = authHeader()
    headers['Content-Type'] = 'multipart/form-data'
    return axios.post('api/services/app/Therapists/UploadTherapistCertificate', data, {
        baseURL: apiConfig.apiUrl,
        headers: headers,
    })
}
function SaveCertPassword(password)
{
    return axios.post('api/services/app/Therapists/SaveCertPassword', {cert_password: password}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}

function getTherapistGroups()
{
    return axios.get('api/services/app/Therapists/GetTherapistGroups', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function addTherapistGroup(data)
{
    return axios.post('api/services/app/Therapists/AddTherapistGroup', data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function deleteTherapistGroup(id)
{
    return axios.delete('api/services/app/Therapists/DeleteTherapistGroup', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}

function updateTherapistGroup(data)
{
    return axios.put('api/services/app/Therapists/UpdateTherapistGroup', data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}